// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/supply_demand_gap_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { SupplyDemandGapService } from "./supply_demand_gap_service_pb";

/**
 * GetSupplyDemandGap returns aggregated supply/demand gap series per area.
 *
 * @generated from rpc bffuser.v1.SupplyDemandGapService.GetSupplyDemandGap
 */
export const getSupplyDemandGap = SupplyDemandGapService.method.getSupplyDemandGap;

/**
 * GetProcurementNeed returns per-area 48-koma procurement need (調達必要量)
 * for the bidding position chart.
 *
 * @generated from rpc bffuser.v1.SupplyDemandGapService.GetProcurementNeed
 */
export const getProcurementNeed = SupplyDemandGapService.method.getProcurementNeed;
